import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import "../EmploymentFinder/EmploymentFinderHomeTypes";
import GenericDialog from '../../moreCore/UI/GenericDialog/GenericDialog';
import "../../moreCore/UI/GenericDialog/GenericDialog";
import { VAMtypes } from "../_loadingHelpers/VAM";
import _TabEnabledMixin from '../../moreCore/UI/Tabbing/_TabEnabledMixin';
import FinderBase from '../FinderBase/FinderBase';

class EvBookingFinderLM extends compose(FinderBase, _TabEnabledMixin) {
	//templateString = template; // Standard verwenden...

    buttonClickTimeout: number = null;

    itemClickDlg: MdsLax<InstanceType<typeof GenericDialog>>;

    //private tableFormatter(cell: StaticTable.StaticTableCell<Types.EvBooking>) {
    //    let node = cell.contentnode;
    //    let entity = cell.entity;
    //    let colName = cell.name;
    //    let value = cell.value;
    //    switch (colName) {
    //        case "date":
    //            let dateFrom = entity.date_start;
    //            let dateTo = entity.date_end;

    //            node.innerHTML = this.dateToString(entity.date_start, "dd.MM.yyyy HH:mm") + " - " + this.dateToString(entity.date_end, "dd.MM.yyyy HH:mm");
    //            break;
    //        default:
    //            node.innerHTML = value;
    //    }
    //}



    openDetailView(row: StaticTable.StaticTableRow<VAMtypes.EvBookingEditorEntity>, rowGroup: StaticTable.StaticTableRowGroup<VAMtypes.EvBookingEditorEntity>) { 

        let entity = rowGroup.entity;

        let data = {
            "EntityId": entity.ID
        }

        this.RequestManager.post(
            window.appRoot + "Calendar/GetItemDetails",
            {
                "jsonData": JSON.stringify(data)
            },
            lang.hitch(this, this._onGetItemData_Response),
            lang.hitch(this, this._onGetItemData_Error)
        );


        this.itemClickDlg = new GenericDialog();
        this.itemClickDlg.destroyOnClose = true;
        this.itemClickDlg.set("header", entity.gDisp_1);
        //dlg.set("content", sContentText );
        this.itemClickDlg.set("closeBtn", true);
        this.itemClickDlg._setTopCloseBtnAttr(true);
        this.itemClickDlg.closeOnEscape = true;
        this.UiModder.domStyle.set(this.itemClickDlg.textNode, "min-height", "100px");
        this.itemClickDlg.show();

        this.StandbyStart(this.itemClickDlg.textNode);


    }
    _onGetItemData_Response(response: string | object): void {

        this.StandbyStop();

        let domConstruct = this.UiModder.domConstruct;
        let domAttr = this.UiModder.domAttr;

        if (typeof (response) == "object") {

            let isHTML: boolean = false;
            let obj = <any>response;

            let text = obj.content;

            if (obj.isHTMLdetailtext) {
                isHTML = true;
                let div = domConstruct.create("div", { "className": "itemDetailHTML" });
                domAttr.set(div, "innerHTML", obj.content);
                text = div.outerHTML;
            }


            if (!isHTML) {
                let pre = domConstruct.create("pre", { "className": "itemDetailText" });
                domAttr.set(pre, "innerHTML", response);
                text = pre.outerHTML;
            }


            this.itemClickDlg._setContentAttr(text);
        }

        else {
            this.itemClickDlg._setContentAttr(response);

        }

    }

    _onGetItemData_Error(Error: any) {
        alert("Error loading item details: " + Error.Message);
        //this.publishToastMessage("Error loading item details", ToasterHelpers.ToasterIcons.error, 10000, Error.Message);
        //this.itemClickDlg.close(); // ? gut oder nicht so?
        this.itemClickDlg._setContentAttr(Error.Message);
        this.itemClickDlg._setHeaderAttr("Error loading item details");
        this.StandbyStop();
    }

    //-----------------------own methods -------------------------end
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        

        this.setTitles(this.translations["EvBooking_AgendaMainTitle"]);
        
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(EvBookingFinderLM);